import { lazy } from 'react'

export default {
    path: '/categorie/:categoriaUtenteId',
    title: 'Categoria: {{params.categoriaUtenteId}}',
    component: lazy(() => import('./detail'))
}